import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { vasthuUrl } from "../component/Api";

const ConsultantContext = createContext();

export const ConsultantProvider = ({ children }) => {
  const alertRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const userId = window.sessionStorage.getItem("userId");
  const token = window.sessionStorage.getItem("token");
  const lang = window.localStorage.getItem("i18nextLng");
  const [walletBalance, setWalletBalance] = useState(0);
  console.log("walletBalance", walletBalance);

  useEffect(() => {
    if (token) {
      try {
        vasthuUrl
          .get(`/getuserbalance/${userId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            setWalletBalance(res.data.balance);
            console.log("res.data", res.data.balance);
          });
      } catch (e) {
        console.log("service", e);
      }
    }
  }, [userId, token, walletBalance]);

  const setAlertFunction = (fn) => {
    alertRef.current = fn;
  };

  const chatAlertCall = () => {
    const id = window.sessionStorage.getItem("consultantId");
    vasthuUrl
      .post(
        "/vasthu/user/calltoconsultant",
        { to: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log("txnres", res.data);
        console.log("Call ringing...");
      })
      .catch((e) => {
        console.log("Error in chatAlertCall:", e);
      });
  };

  const handleWalletCall = () => {
    const consultant = window.sessionStorage.getItem("consultantId");
    const user = window.sessionStorage.getItem("userId");
    try {
      vasthuUrl
        .post(`/vasthu/user/callFromUserToConsultant`, {
          from: consultant,
          to: user,
        })
        .then((res) => {
          console.log("callllllllllllll", res);
          if (res.status == 200) {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.PROCED.BTN"), "success");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.PROCED.BTN" },
              });
            }, 1000);
          } else {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.FAILD.BTN"), "error");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.FAILD.BTN" },
              });
            }, 1000);
          }
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const handleFreeCall = () => {
    const consultant = window.sessionStorage.getItem("consultantId");
    const user = window.sessionStorage.getItem("userId");
    try {
      vasthuUrl
        .post(`/vasthu/user/callFromUserToConsultantfree`, {
          from: consultant,
          to: user,
        })
        .then((res) => {
          if (res.status == 200) {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.PROCED.BTN"), "success");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.PROCED.BTN" },
              });
            }, 100);
          } else {
            if (alertRef.current) {
              alertRef.current(t("USR.CAL.FAILD.BTN"), "error");
            }
            setTimeout(() => {
              navigate("/audiocallstatus", {
                state: { callStatus: "USR.CAL.FAILD.BTN" },
              });
            }, 1000);
          }
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const handleDataCall = () => {
    const userId = window.sessionStorage.getItem("userId");
    const consultantId = window.sessionStorage.getItem("consultantId");
    const consultantType = window.sessionStorage.getItem("consultantType");

    try {
      vasthuUrl
        .post(`/datacall/initiateSession`, {
          from: userId,
          to: consultantId,
          lng: lang,
          type:
            consultantType === "Call" || consultantType == "Wallet"
              ? "Call"
              : // "WALLET"
                "FREECALL",
        })
        .then((res) => {
          console.log("Data Call", res.status);
          navigate("/datacall");
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const handleInitiate = () => {
    const userId = window.sessionStorage.getItem("userId");
    const consultantId = window.sessionStorage.getItem("consultantId");
    const consultantType = window.sessionStorage.getItem("consultantType");

    try {
      vasthuUrl
        .post(`/initiateChat`, {
          from: userId,
          to: consultantId,
          lng: lang,
          // type: consultantType.toLocaleLowerCase(),
        })
        .then((res) => {
          console.log("chat after", res.status);
          navigate("/chatscreen");
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const handleFreeChat = () => {
    const userId = window.sessionStorage.getItem("userId");
    const consultantId = window.sessionStorage.getItem("consultantId");
    try {
      vasthuUrl
        .post(`/initiateChat/makeFreeChat`, {
          from: userId,
          to: consultantId,
          lng: lang,
        })
        .then((res) => {
          console.log("chat after", res.status);
          navigate("/chatscreen");
          window.sessionStorage.removeItem("pendingAction");
        });
    } catch (e) {
      console.log("err", e);
    }
  };

  const memoedValue = useMemo(
    () => ({
      setAlertFunction,
      chatAlertCall,
      handleWalletCall,
      handleFreeCall,
      handleInitiate,
      handleFreeChat,
      walletBalance,
      setWalletBalance,
      handleDataCall,
    }),
    [walletBalance, setWalletBalance]
  );

  return (
    <ConsultantContext.Provider value={memoedValue}>
      {children}
    </ConsultantContext.Provider>
  );
};

export const UseConsultant = () => {
  return useContext(ConsultantContext);
};
